import { useLang } from 'hooks/lang';

import { Column, TripleRingLoader } from 'components/Blocks';

export function LoginValidation() {
  const { t } = useLang();

  return (
    <Column gap="6" alignItems="center">
      <h2 className="text-2xl">{t('validating-credentials')}...</h2>

      <TripleRingLoader />
    </Column>
  );
}
